import { APIRequest } from '../../helpers/index.helper';
import { APP_TEXT_ENDPOINT } from '../../apiEndpoints/index.endpoint';
import { logger } from '../../utils';
export const financingInformationService = async (body) => {
  try {
    const payload = {
      ...APP_TEXT_ENDPOINT.financingInformation,
      bodyData: body,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};
